function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export const Context = /*#__PURE__*/React.createContext({
  state: {},
  manager: null,
  printer: null,
  localApis: null
});
export const useLocalService = () => React.useContext(Context);
export const useLocalServiceManager = () => useLocalService().manager;
export const useLocalServiceState = () => useLocalService().state;
export const usePrinter = () => useLocalService().printer;
export const useLocalApis = () => useLocalService().localApis;
export const withLocalService = Component => props => /*#__PURE__*/React.createElement(Context.Consumer, null, context => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
  localService: context
})));
export const withLocalServiceManager = Component => props => /*#__PURE__*/React.createElement(Context.Consumer, null, context => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
  localManager: context.manager
})));
export const withLocalServiceState = Component => props => /*#__PURE__*/React.createElement(Context.Consumer, null, context => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
  localServiceState: context.state
})));
export const withPrinter = Component => props => /*#__PURE__*/React.createElement(Context.Consumer, null, context => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
  printer: context.printer
})));
export const withLocalApis = Component => props => /*#__PURE__*/React.createElement(Context.Consumer, null, context => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
  localApis: context.localApis
})));